/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



$(document).ready(function() {
  $('.featured-product-list_grid.slider').each(function() {
    
    var desktopSlidesToShow = parseInt($(this).attr('desktop_per_row'));
    var mobileSlidesToShow = parseInt($(this).attr('mobile_per_row'));
    
    $(this).slick({
      dots: true,
      slidesToShow: desktopSlidesToShow,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: mobileSlidesToShow
          }
        }
      ]
    });
  });

  $('.featured-product-slider_wrap').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false
  });
  $(".tc-wrapper").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".testimonial-sec-blocks").slick({
      arrows:true,
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2
          }
        }
      ],
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });

  $(".brans-highlights_row").slick({
      arrows:false,
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerMode: true,
          centerPadding: '25%',
        }
      }
    ]
  }); 

  $(".partners-logo_row").slick({
      arrows:false,
      dots: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerMode: true,
          centerPadding: '25%',
        }
      }
    ]
  }); 

  $(".awards-section-media-blocks").slick({
      arrows:true,
      dots: false,
      infinite: true,
      autoplay: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: 'unslick'
      }
    ]
  }); 
  
  $('.faq-view_more_less').click(function(){
      $(this).parents('.faq').find('.show_on_view_more').toggle();
      if ($(this).text() == "View More") {
      $(this).text("View less")
    } else {
      $(this).text("View More")
    }
  });

  $("body").on("click", ".offer-code-copy", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $(this).parents('.available-offers').append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // $('.warranty-offer-box-link').on('click',function (e) {
  //     var target = this.hash,
  //         $target = $(target);
  //     $('html').removeClass('lock-all');
  //     $('html, body').stop().animate({
  //       'scrollTop': $target.offset().top-70
  //     }, 900, 'swing', function () {
  //       window.location.hash = target;
  //     });
  //   });
  
  $(".warranty-box-link").click(function(e) {
    e.preventDefault();
    $('.warranty-tab[aria-expanded="false"]').trigger('click');
    setTimeout(function(){ 
      $('html, body').animate({
          scrollTop: $(".warranty-tab-content").offset().top-280
      }, 1000);
    }, 500);
  });
    $('.offer-box-link').click(function(e){
      e.preventDefault();
      $(this).parents('.offer_box-main').find('.available-offers').slideToggle();
      $(this).toggleClass('active');
  })

  $('.seo-content_toggle').click(function(){
    console.log('00');
   $('.seo-content').toggle();
  });

  $("body").on("click", ".pfitb-read-more", function (){
    $(this).closest('.pro-form-icon-text-block').find('.pfitb-modal').attr('open', '');
  })
  $("body").on("click", ".pfitb-button-close, .pfitb-overlay", function (){
    $(this).closest('.pro-form-icon-text-block').find('.pfitb-modal').removeAttr('open', '');
  })

  //set cookie
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
    $('.visitindia_store_btn').removeAttr('hidden');
    var delaydays = parseInt($(this).closest('.ctryModal-Content').attr('data-delaydays'));
    setCookie('redirectchoice',true,delaydays);
    window.location.href = 'https://luckyharvey.com/en-in';
  });

  if(getCookie('redirectchoice')){
    $('.visitindia_store_btn').removeAttr('hidden');
  }

  $('.seo-read-more-less_link').click(function(e){
    e.preventDefault();
    if($(this).closest('.seo-content_text-wrapper').hasClass('active')){
      $(this).text('Read More').closest('.seo-content_text-wrapper').removeClass('active');
    }else{
      $(this).text('Read Less').closest('.seo-content_text-wrapper').addClass('active');
    }
  });
  
});

$(function () {
  var $header = $('.shopify-section--header');
  var $videoBtn = $('.pdp-video-call-btn-wrap');
  var lastY = $(window).scrollTop();

  $(window).on('scroll', function () {
    var y = $(window).scrollTop();
    var offset = $header.outerHeight();

    if (Math.abs(y - lastY) < 5) return;

    var hide = y > lastY && y > offset;

    $header.toggleClass('is-hidden', hide);
    $videoBtn.toggleClass('is-header-hidden', hide);

    lastY = y;
  });
});